import React, { useState } from 'react'

import Layout from '../components/Layout'
import FormTemplate, {UploadPage} from '../components/Form'

const InitializePost = () => {
    return (
        <>
        <p>Initiate Post</p>
        <FormTemplate />
        </>
    )
}

const UploadImage = () => {
    return (
        <>
        <p>Upload Image</p>
        <UploadPage />
        </>
    )
}

const AddPost = ({ location }) => {
    const [post, setPost ] = useState('')

    function display(e) {
        // console.log(e.target.textContent)
        setPost(
            e.target.textContent === "Initialize Post" ? <InitializePost /> : <UploadImage />
        )
    }
    
    return (
        <Layout location={location}>
            <>
            <button onClick={display}>
                Initialize Post
            </button>
            <button onClick={display}>
                Upload Image
            </button>
            </>
            <div>
                {post}
            </div>
            
        </Layout>
    )
}

export default AddPost
